import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 3v15a3 3 0 0 1 -6 0v-15","key":"svg-0"}],["path",{"d":"M9 12h6","key":"svg-1"}],["path",{"d":"M8 3h8","key":"svg-2"}]]

/**
 * IconTestPipe2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdGVzdC1waXBlLTIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE1IDN2MTVhMyAzIDAgMCAxIC02IDB2LTE1IiAvPgogIDxwYXRoIGQ9Ik05IDEyaDYiIC8+CiAgPHBhdGggZD0iTTggM2g4IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/test-pipe-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTestPipe2 = createReactComponent('outline', 'test-pipe-2', 'TestPipe2', __iconNode);

export default IconTestPipe2;